export const TABS = [
  {
    title: "外观",
    name: "appearance",
  },
  {
    title: "舱房",
    name: "cabins",
  },
  {
    title: "美食",
    name: "restaurants",
  },
  {
    title: "娱乐",
    name: "plays",
  },
  {
    title: "服务",
    name: "service",
  },
];
export const FontIcon = [
  {
    title: "外观",
    name: "ficon-tupian1",
  },
  {
    title: "舱房",
    name: "ficon-cangfangxinxi",
  },
  {
    title: "美食",
    name: "ficon-meishi1",
  },
  {
    title: "娱乐",
    name: "ficon-yule1",
  },
  {
    title: "服务",
    name: "ficon-gongzuorenyuan",
  },
];